import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {rxResource} from '@angular/core/rxjs-interop';
import {AbstractAssetComponent} from '../abstract-asset.component';
import type {AssetPersonEvents, PersonEvent} from 'src/app/common/models/ai-reports/shared/assets';
import {ChatStore} from 'src/app/services/store';
import {environment} from 'src/environments/environment';

interface PersonEventsJson {
  personId: number;
  personName: string;
  events: PersonEvent[];
}

@Component({
  selector: 'app-asset-person-events',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-person-events.component.html',
  styleUrl: './asset-person-events.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetPersonEventsComponent extends AbstractAssetComponent<AssetPersonEvents> {
  private readonly chatStore = inject(ChatStore);
  private readonly httpClient = inject(HttpClient);

  protected readonly threadId = this.chatStore.thread_id;

  private readonly fetchParams = computed(() => {
    if (this.mode() === 'thumbnail') return undefined;
    return {
      threadId: this.chatStore.thread_id(),
      assetId: this.asset().id,
    };
  });

  readonly dataResource = rxResource({
    params: this.fetchParams,
    stream: ({params}) =>
      this.httpClient.get<PersonEventsJson>(
        `${environment.apiBaseUrl}/assets/${params.threadId}/${params.assetId}/image`
      ),
  });

  photoUrl(photoAssetId: string): string {
    return `${environment.apiBaseUrl}/assets/${this.chatStore.thread_id()}/${photoAssetId}/image`;
  }
}
